import { createReducer, on } from '@ngrx/store';
import * as spinnerActions from '../actions/spinner.action';

export interface State {
  show: boolean;
}

const initialState: State = {
	show: false
};

export const reducer = createReducer(
  initialState,
  on(spinnerActions.Show, (state, action) => ({
    ...state,
    show: true,
  })),
  on(spinnerActions.Hide, (state, action) => ({
    ...state,
    show: false,
  })),
);
